module.exports = __webpack_public_path__ + "img/analysis.d6721395.png";